import * as React from "react";

export const LocationReload = () => {
  React.useEffect(() => {
    window.location.reload();
  }, []);
  return null;
};
